import { render } from "./FileUploadInput.vue?vue&type=template&id=2d6a04e6&scoped=true"
import script from "./FileUploadInput.vue?vue&type=script&lang=js"
export * from "./FileUploadInput.vue?vue&type=script&lang=js"

import "./FileUploadInput.vue?vue&type=style&index=0&id=2d6a04e6&lang=scss&scoped=true"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6a04e6"]])

export default __exports__